var render, staticRenderFns
import script from "./Teleport.vue?vue&type=script&lang=js"
export * from "./Teleport.vue?vue&type=script&lang=js"
import style0 from "./Teleport.vue?vue&type=style&index=0&id=b7d9c1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d9c1c2",
  null
  
)

export default component.exports